import { EventDispatcher } from '@foxandfly/ts-event-dispatcher'

export const dispatcher = new EventDispatcher()
